import { appBackendApiClient } from './apiClient';
import { DonationTransactionRow } from '../types';

interface ReportFilters {
  startDate?: string;
  endDate?: string;
  causeId?: string;
  status?: string;
  limit?: number;
}

export const ReportingService = {
  listDonationTransactions: async (
    filters: ReportFilters
  ): Promise<DonationTransactionRow[]> => {
    const response = await appBackendApiClient.get(
      '/donations/admin/transactions',
      {
        params: filters,
      }
    );
    return response.data.map((row: DonationTransactionRow) => ({
      ...row,
      amount: Number(row.amount),
    }));
  },
};
